/**
 * Submission files may be PDF or raster images. PDFs must not be loaded with <img>
 * (wrong MIME → cross-origin ORB failures). Use this to branch preview UI.
 */
export function isSubmissionPdf(filename?: string | null, signedUrl?: string | null): boolean {
  const fn = (filename || "").trim().toLowerCase();
  if (fn.endsWith(".pdf")) return true;
  const raw = (signedUrl || "").trim();
  if (!raw) return false;
  try {
    const u = new URL(raw);
    return u.pathname.toLowerCase().endsWith(".pdf");
  } catch {
    const base = raw.split("?")[0]?.toLowerCase() ?? "";
    return base.endsWith(".pdf");
  }
}
